import { Component, OnInit,OnDestroy } from '@angular/core';
import { Subscription } from "rxjs";
import { LoadingService } from './Loading.service';

@Component({
  selector: 'app-Loader',
  templateUrl: './Loader.component.html'
})
export class LoaderComponent  implements OnInit, OnDestroy {

  loading: boolean = false;
  loadingSubscription: Subscription;

  constructor(private loadingScreenService: LoadingService) {
  }

  ngOnInit() {
    this.loadingSubscription = this.loadingScreenService.loadingStatus.subscribe((value) => {
      this.loading = value;
    });
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
  }

}
